/* eslint-disable max-len */
import { organizationusersList } from "./apiSlice";

const patientList = organizationusersList.injectEndpoints({
    tagTypes: ['Patient', 'SelectedSubdivPatient', 'PatientMonitorUser', 'PatientActivityHistory', 'PatientHistoryExport'],
    endpoints: (builder) => ({
        getPatients: builder.query({
            query: (searchParams) => `patients?${searchParams}`,
            providesTags: (result = [], error, arg) => error === undefined ? [

                'Patient',
                ...result?.data !== undefined && Array.isArray(result?.data) && result?.data?.map(({ _id }) => ({ type: 'Patient', id: _id }))
            ] : []
        }),
        addPatient: builder.mutation({
            query: org => ({
                url: `/patients/`,
                method: 'POST',
                body: org
            }),
            invalidatesTags: ['Patient']
        }),
        getPatientSubdivisions: builder.query({
            query: (searchParams) => `organizations/list-subdivisions?${searchParams}`,
            providesTags: (result = [], error, arg) => error === undefined ? [

                'SelectedSubdivPatient',
                ...result?.data !== undefined && Array.isArray(result?.data) && result?.data?.map(({ _id }) => ({ type: 'SelectedOrg', id: _id }))
            ] : [],
        }),

        getPatient: builder.query({
            query: (id) => `/patients/${id}`,
            providesTags: (result, error, arg) => [{ type: 'Patient', id: arg }]
        }),
        editPatient: builder.mutation({
            query: ({ id, body }) => ({
                url: id !== undefined ? `/patients/${id}` : `/patients/`,
                method: 'PATCH',
                body: body
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'Patient', id: arg.id }]
        }),
        viewPatient: builder.query({
            query: (id) => `/patients/${id}`,

            providesTags: (result, error, arg) => [{ type: 'Patient', id: arg }],
            invalidatesTags: ['PatientActivityHistory']
        }),
        // export patient api call
        exportPatients: builder.mutation({
            query: ({ queryString, columns, dateformat }) => ({
                url: `/patients/export-list?${queryString}`,
                method: 'POST',
                body: { "columns": columns, "dateformat": dateformat, "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone }
            }),
        }),
        addNotes: builder.mutation({
            query: org => ({
                url: `/patients/add-notes`,
                method: 'POST',
                body: org
            }),
            invalidatesTags: ['Patient']
        }),
        // activity history
        patientActivityHistoryList: builder.query({
            query: (searchParams) => `patients/list-changes?${searchParams}`,
            providesTags: ['PatientActivityHistory']

        }),
        exportPatientActivityHistory: builder.mutation({
            query: ({ sort, columns, username, dateformat, params }) => {
                const queryParams = Object.entries(params)
                    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                    .join('&');
                return {
                    url: `patients/export-profile-changes?${queryParams}`,
                    method: 'POST',
                    body: { "columns": columns, "target_user_name": username, "dateformat": dateformat, "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone }
                };
            },
        }),
        exportPatientNotes: builder.mutation({
            query: ({ dateformat, patientId, noteType }) => ({
                url: `patients/export-note/${patientId}?note_type=${noteType}`,
                method: 'POST',
                body: { "dateformat": dateformat, "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone, }
            }),
        }),
        // view patient export history
        getPatientViewExportHistory: builder.query({
            query: (searchParams) => `patients/list-export-history?${searchParams}`,
            providesTags: (result = [], error, arg) => error === undefined ? [
                'PatientHistoryExport'] : [],
        }),
        // export patient export history
        exportPatientExportLog: builder.mutation({
            query: ({ columns, dateformat, username }) => ({
                url: `patients/export-history`,
                method: 'POST',
                body: { "columns": columns, "dateformat": dateformat, "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone, "target_user": username }
            }),
            invalidatesTags: ['PatientActivityHistory']
        }),
        getHelpGuideOrganization: builder.query({
            query: (queryParams) => ({
                url: `users/help-guides?${queryParams}`,
                method: 'GET',
            }),
            providesTags: ['Patient'], // Optional: useful for cache invalidation
        }),
        getHelpGuideOrganizationLogin: builder.query({
            query: (queryParams) => ({
                url: `users/help-guide-login?${queryParams}`,
                method: 'GET',
            }),
            providesTags: ['Patient'], // Optional: useful for cache invalidation
        }),
        // transfer file
        transferFile:builder.mutation({
            query:org=>({
                url:`/transfer-file`,
                method:'POST',
                body:org
            }),
        }),
        // transfer file
        ActivityHistoryFileTransfer:builder.mutation({
            query:org=>({
                url:`users/record-activity`,
                method:'POST',
                body:org
            }),
        }),



    }),

    overrideExisting: false
})


export const {
    useAddPatientMutation,
    useLazyGetPatientSubdivisionsQuery,
    useLazyGetPatientQuery,
    useViewPatientQuery,
    useEditPatientMutation,
    useExportPatientsMutation,
    useGetPatientsQuery,
    useAddNotesMutation,
    usePatientActivityHistoryListQuery,
    useExportPatientActivityHistoryMutation,
    useExportPatientNotesMutation,
    useGetPatientViewExportHistoryQuery,
    useExportPatientExportLogMutation,
    useLazyViewPatientQuery,
    useGetHelpGuideOrganizationQuery,
    useGetHelpGuideOrganizationLoginQuery,
    useTransferFileMutation,
    useActivityHistoryFileTransferMutation,
} = patientList